/**
 * This file contains prop => style functions related to UI element CSS white-space prop
 * Standalone prop for now, this may get folded in with other wrapping properties in the the future
 */
import { stringLiteralArray } from "./utils"

export type WhiteSpace = typeof whiteSpaceValues[number]
export type WhiteSpaceProp = {
  /**
   * The CSS textAlign style.
   */
  whiteSpace?: WhiteSpace
}

const whiteSpaceValues = stringLiteralArray([
  "break-spaces",
  "normal",
  "nowrap",
  "pre",
  "pre-wrap",
  "pre-line"
])

const whiteSpace = ({
  whiteSpace
}: Record<string, any>): {} | { whiteSpace: WhiteSpace } => {
  return whiteSpace === undefined ? {} : { whiteSpace }
}

export { whiteSpaceValues, whiteSpace }
